'use client'

import SectionLayout from '@component/layout/section'
import { isEqual } from 'lodash-es'
import HousePropertyValueContext, { TABS, useHousePropertyValueState } from './context'
import Histories from './history'
import OverTime from './overTime'
import PropertyEstimate from './propertyEstimate'
import RatingValuation from './ratingValuation'
import HousePropertyValueTabs from './tabs'
import EstimateTrack from './track'
import FindEstimate from './findEstimate'
import { isPropertyData } from '@utils/house'

export default function PropertyValueContent({
  data,
  overTime,
  histories
}) {

  const state = useHousePropertyValueState(data, overTime, histories)
  const { tab } = state
  const isProperty = isPropertyData(data)

  return (
    <HousePropertyValueContext.Provider value={{ ...state, data, overTime }}>
      <SectionLayout title='Property insights' titleRight={<HousePropertyValueTabs></HousePropertyValueTabs>} contentClassName='!mt-0'>
        <div className='rounded-b-sm md:border md:p-20'>
          {
            isEqual(tab, TABS.estimate) && (
              <PropertyEstimate data={data}>
                {
                  isProperty
                    ? <EstimateTrack data={data}></EstimateTrack>
                    : <FindEstimate data={data}></FindEstimate>
                }
              </PropertyEstimate>
            )
          }
          {
            isEqual(tab, TABS.rv) && (
              <RatingValuation data={data}>
                <EstimateTrack data={data}></EstimateTrack>
              </RatingValuation>
            )
          }
          {
            isEqual(tab, TABS.overTime) && (
              <OverTime data={overTime}></OverTime>
            )
          }
          {
            isEqual(tab, TABS.history) && (
              <Histories data={histories}></Histories>
            )
          }
        </div>
      </SectionLayout>
    </HousePropertyValueContext.Provider>
  )
}